import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, chakra, IconButton, Link as ChakraLink } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
export const RouteLink = ({ to , as =to , children , replace , scroll , shallow , prefetch , locale , ...props })=>{
    return(/*#__PURE__*/ _jsx(NextLink, {
        passHref: true,
        href: to,
        as: as,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        children: /*#__PURE__*/ _jsx(ChakraLink, {
            ...props,
            children: children
        })
    }));
};
export const OutgoingLink = ({ children , isExternal =true , externalIcon =null , ...props })=>{
    const Icon = externalIcon && chakra(externalIcon);
    return(/*#__PURE__*/ _jsxs(ChakraLink, {
        isExternal: isExternal,
        ...props,
        children: [
            children,
            Icon && /*#__PURE__*/ _jsx(Icon, {
                display: "inline-block",
                mx: "0.2em",
                fontSize: "0.8em",
                "aria-label": "(external link)"
            })
        ]
    }));
};
export const ButtonRouteLink = ({ to , as =to , replace , scroll , shallow , prefetch , locale , children , ...props })=>/*#__PURE__*/ _jsx(NextLink, {
        passHref: true,
        href: to,
        as: as,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        locale: locale,
        children: /*#__PURE__*/ _jsx(Button, {
            as: "a",
            ...props,
            children: children
        })
    })
;
export const IconButtonRouteLink = ({ ...props })=>{
    return(/*#__PURE__*/ _jsx(IconButton, {
        as: RouteLink,
        ...props
    }));
};
export const IconButtonOutgoingLink = ({ ...props })=>{
    return(/*#__PURE__*/ _jsx(IconButton, {
        as: OutgoingLink,
        ...props
    }));
};
export const navLinkMatch = {
    exact: ({ as , router  })=>router?.asPath === as
    ,
    startsWith: ({ as , router  })=>router?.asPath?.startsWith(as) || false
};
export const NavLink = ({ active: activeProps = {
    textDecoration: 'underline'
} , shouldBeActive =navLinkMatch.startsWith , to , as =to , ...props })=>{
    const router = useRouter();
    const active = shouldBeActive({
        to,
        as,
        router
    });
    return(/*#__PURE__*/ _jsx(RouteLink, {
        ...active ? activeProps : {},
        as: as,
        to: to,
        ...props
    }));
};
